import Vue from 'vue';

const state = {
    order:{
        details:{
            product_id:0,
            quantity:0,
            selections:[],
            extra_selections:[]
        },
        information:{
            firstname:'',
            lastname:'',
            address:'',
            zipcode:'',
            city:'',
            email:'',
            phone:'',
            notes:'',
            company_name:'',
            cvr:'',
            ean:'',
        },
        delivery:{
            with_delivery:false,
            deliver_at:'',
            information:{
                firstname:'',
                lastname:'',
                address:'',
                zipcode:'',
                city:'',
                email:'',
                phone:''
            },
            delivery_notes:'',
            delivery_fee:0,
        },
        token:'',
        invoiceLink:'',
        order_uuid:'',
        coupon:'',
    },
    flow:{
        completedProduct:false,
        completedSummary:false,
        completedInformation:false,
        completedDelivery:false,
        completedPayment:false,
    },
    card_error:null,
    couponData: null,
};

const getters = {
    order: state => state.order,
    selectionsValid: state => {
        let valid = true;
        state.order.details.selections.forEach(item => {
            if(item.options.length < item.min_options){
                valid = false;
            }
        });

        return valid;
    },
    customSelectionsValid: state => {
        let valid = true;
        state.order.details.selections.forEach(selection => {
            if(selection.options.length === 0){
                valid = false;
                return;
            }

            const optionQuantity = selection.options.map(option => option.quantity).reduce((acc, cur) => acc + cur);
            if(optionQuantity !== state.order.details.quantity){
                valid = false;
            }
        });

        return valid;
    },

    completedProduct: state => state.flow.completedProduct,
    completedSummary: state => state.flow.completedSummary,
    completedInformation: state => state.flow.completedInformation,
    completedDelivery: state => state.flow.completedDelivery,
    completedPayment: state => state.flow.completedPayment,
    token: state => state.order.token,
    cardError: state => state.card_error,
    couponData: state => state.couponData,
};

const actions = {
    resetOrder({commit}){
        commit('resetOrder');
    },
    setOrderProduct({commit}, product){
        commit('setOrderProduct', product);
    },
    setQuantity({commit}, quantity){
        commit('setQuantity', quantity);
    },
    setSelections({commit}, selections){
        commit('setSelections', selections.map(item => {
            return {
                selection_id: item.id,
                min_options: item.min_options,
                options:[],
            }
        }));
    },
    setExtraSelections({commit}, selections){
        commit('setExtraSelections', selections.map(item => {
            return {
                extra_selection_id: item.id,
                options:[],
            }
        }));
    },
    setCustomSelections({commit}, selections){
        commit('setSelections', selections.map(item => {
            return {
                selection_id: item.id,
                options:[],
            }
        }));
    },
    setCustomExtraSelections({commit}, selections){
        commit('setExtraSelections', selections.map(item => {
            return {
                extra_selection_id: item.id,
                options:[],
            }
        }));
    },
    setOptionForSelection({commit}, payload){
        commit('setOptionForSelection', payload);
    },
    setOptionForExtraSelection({commit}, payload){
        commit('setOptionForExtraSelection', payload);
    },
    setOptionForCustomSelection({commit}, payload){
        commit('setOptionForCustomSelection', payload);
    },
    setOptionForCustomExtraSelection({commit}, payload){
        commit('setOptionForCustomExtraSelection', payload);
    },
    setInformation({commit}, information){
        commit('setInformation', information);
    },
    setToken({commit}, token){
        commit('setToken', token);
    },
    setDelivery({commit}, delivery){
        commit('setDelivery', delivery);
    },
    setInvoiceLink({commit}, response){
        commit('setInvoiceLink', response);
    },
    completedProduct({commit}){
        commit('completedProduct');
    },
    completedSummary({commit}){
        commit('completedSummary');
    },
    completedInformation({commit}){
        commit('completedInformation');
    },
    completedDelivery({commit}){
        commit('completedDelivery');
    },
    completedPayment({commit}){
        commit('completedPayment');
    },
    setCardError({commit}, cardError){
        commit('setCardError', cardError);
    },
    setCoupon({commit}, coupon){
        commit('setCoupon', coupon);
    },
    clearCoupon({commit}){
        commit('clearCoupon');
    }
};

const mutations = {
    resetOrder(state){
        state.order = {
            details:{
                product_id:0,
                quantity:0,
                selections:[],
                extra_selections:[]
            },
            information:{
                firstname:'',
                lastname:'',
                address:'',
                zipcode:'',
                city:'',
                email:'',
                phone:''
            },
            delivery:{
                with_delivery:false,
                deliver_at:'',
                information:{
                    firstname:'',
                    lastname:'',
                    address:'',
                    zipcode:'',
                    city:'',
                    email:'',
                    phone:'',
                    notes:'',
                },
                delivery_notes:'',
                delivery_fee:'',
            },
            token:'',
        };
    },
    setOrderProduct(state, product){
        state.order.details.product_id = product.id;
    },
    setQuantity(state, quantity){
        state.order.details.quantity = quantity;
    },
    setSelections(state, selections){
        state.order.details.selections = selections;
    },
    setExtraSelections(state, selections){
        state.order.details.extra_selections = selections;
    },
    setOptionForSelection(state, payload){
        const index = state.order.details.selections.findIndex(item => item.selection_id == payload.selection.id);

        if(state.order.details.selections[index].options.includes(payload.option.id)){
            return state.order.details.selections[index].options = state.order.details.selections[index].options.filter(item => item !== payload.option.id);
        }

        if(state.order.details.selections[index].options.length == payload.selection.min_options){
            return;
        }

        state.order.details.selections[index].options.push(payload.option.id);
    },
    setOptionForExtraSelection(state, payload){
        const index = state.order.details.extra_selections.findIndex(item => item.extra_selection_id == payload.selection.id);

        if(state.order.details.extra_selections[index].options.includes(payload.option.id)){
            return state.order.details.extra_selections[index].options = state.order.details.extra_selections[index].options.filter(item => item !== payload.option.id);
        }

        state.order.details.extra_selections[index].options.push(payload.option.id);
    },
    setOptionForCustomSelection(state, payload){
        const index = state.order.details.selections.findIndex(item => item.selection_id == payload.selection.id);

        if(payload.option.quantity <= 0){
            return state.order.details.selections[index].options = state.order.details.selections[index].options.filter(item => item.id !== payload.option.id);
        }

        if(state.order.details.selections[index].options.find(item => item.id === payload.option.id) && payload.option.quantity > 0){

            state.order.details.selections[index].options = state.order.details.selections[index].options.filter(item => item.id !== payload.option.id);

        }

        state.order.details.selections[index].options.push(payload.option);
    },
    setOptionForCustomExtraSelection(state, payload){
        const index = state.order.details.extra_selections.findIndex(item => item.extra_selection_id == payload.selection.id);

        if(payload.option.quantity <= 0){
            return state.order.details.extra_selections[index].options = state.order.details.extra_selections[index].options.filter(item => item.id !== payload.option.id);
        }

        if(state.order.details.extra_selections[index].options.find(item => item.id === payload.option.id) && payload.option.quantity > 0){
            state.order.details.extra_selections[index].options = state.order.details.extra_selections[index].options.filter(item => item.id !== payload.option.id);
        }

        state.order.details.extra_selections[index].options.push(payload.option);
    },
    setInformation(state, information){
        state.order.information = information;
    },
    setToken(state, token){
        state.order.token = token;
    },
    setDelivery(state, delivery){
        state.order.delivery = delivery;
    },
    setInvoiceLink(state, response){
        state.order.invoiceLink = response.invoice;
        state.order.order_uuid = response.order_uuid;
    },
    completedProduct(state){
        state.flow.completedProduct = true;
    },
    completedSummary(state){
        state.flow.completedSummary = true;
    },
    completedInformation(state){
        state.flow.completedInformation = true;
    },
    completedDelivery(state){
        state.flow.completedDelivery = true;
    },
    completedPayment(state){
        state.flow.completedPayment = true;
    },
    setCardError(state, cardError){
        state.card_error = cardError;
    },
    setCoupon(state, coupon){
        state.order.coupon = coupon.code;
        state.couponData = coupon;
    },
    clearCoupon(state){
        state.order.coupon = '';
        state.couponData = null;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
